import React from 'react';
import { marketCategories } from '../../../../utils/market';
import MenuContainer from './CategoryDropdown';
import InputWithButton from './InputWithButton';
import { useSelector } from 'react-redux';

const SearchFieldWithoutSuggestions = ({
  withoutPostType = false,
  isMarket = false,
  searchText,
  setSearchText,
  selectedPostType,
  setSelectedPostType,
  closeSearchDrawer = Function,
}) => {
  const lang = useSelector(({ common }) => common?.language);
  // const [searchText, setSearchText] = useState(null);
  // const [selectedPostType, setSelectedPostType] = useState(null);

  return (
    <div className={`flex items-center border bg-white `}>
      {withoutPostType ? null : (
        <MenuContainer
          className=''
          label={lang?.common?.all}
          setSelected={setSelectedPostType}
          menus={[
            {
              id: null,
              name: lang?.common?.all,
            },
            ...marketCategories(lang).filter((item) => item.id !== 'for_you'),
          ]}
        />
      )}
      <InputWithButton
        closeSearchDrawer={closeSearchDrawer}
        placeholder={
          isMarket ? lang?.common?.search_by_market : lang?.common?.search_by
        }
        // isRounded={isRounded}
        searchText={searchText}
        setSearchText={setSearchText}
        withPostType={true}
        postType={selectedPostType}
        isHovering={true}
      />
    </div>
  );
};

export default SearchFieldWithoutSuggestions;
